import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMUsageTier } from "../graphql/mutations";
import { UpdateLLMUsageTierMutation, LLMUsageTierStatus } from "../API";

export async function activateLLMUsageTier(
  id: string
): Promise<GraphQLResult<UpdateLLMUsageTierMutation>> {
  const nowIso = new Date().toISOString();
  return API.graphql(
    graphqlOperation(updateLLMUsageTier, {
      input: {
        id,
        status: LLMUsageTierStatus.ACTIVE,
        activeAt: nowIso,
        inactiveAt: null, // Clear inactiveAt when activating
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMUsageTierMutation>>;
}
